<template lang="pug">
    section.selector

        .selector__curtain(
            ref='curtain'
            )

        .selector__opg(
            v-if='$attrs.category === "opg"'
            )

            .opg

                .opg__intro-wrapper(
                    ref='introwrapper'
                    )

                    .opg__bullets
                        .opg__bullets-bullet(
                            v-for='bullet in 2',
                            ref='bullet'
                            )
                            svg(width='228', height='47', viewBox='0 0 228 47', fill='none', xmlns='http://www.w3.org/2000/svg')
                                path(fill-rule='evenodd', clip-rule='evenodd', d='M159.309 36.719C201.842 36.439 228 29.025 228 23.5c0-5.525-26.158-12.939-68.691-13.219V36.72zm1.734-20.843V12.52c41.076.42 66.263 6.505 66.263 11.05.07-3.216-25.117-7.413-66.263-7.692zM107.824 47h-97c-.625 0-1.11-.42-1.11-.91V.91c0-.49.485-.91 1.11-.91h97l21.996 8.882h28.517v29.236H129.82L107.824 47zm47.946-29.585V12.8h-25.881l-22.065-6.504H12.35v7.413h95.474l21.996 3.707h25.95zM6.245 46.51H.833c-.417 0-.833-.42-.833-.909V1.47c0-.49.416-.91.833-.91h5.412v45.952z', fill='#fff')

                    .opg__blooddrop
                        
                        svg(xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', viewBox='0 0 248.11 523.89', width='200', height='422')
                            defs
                                clipPath#clip-path-gg
                                    path(d='M105.53,88a6,6,0,0,1,3.5-2.79,37.94,37.94,0,0,1,8.91,0c.87.17,1.92,1.39,2.62,2.44,1.75,3.15,2.62,3.15,4.72.35.52-.7,1.39-1.22,2.79-2.62-.35,5.07,2.8,7.16,5.07,9.79,1.92,2.44,1.22,5.24,1.57,7.86.17.52-1.05,1.57-1.92,1.92a8.91,8.91,0,0,1-7-.35,73.57,73.57,0,0,0-14-4.89C106.41,98.52,104.14,91.89,105.53,88ZM92.78,241.43c1.4-1.92,1.57-4.71.35-6.11a3.2,3.2,0,0,0-2.62-1c-4.37,1.22-9.08,1.4-12.75,4.89a7.42,7.42,0,0,1-3.5,1.05c-.7.18-1.57-.17-2.09,0-5.07,1.92-10.14,4-14.33,7.69A8.57,8.57,0,0,1,50.33,250c-1.92-.34-3.85-.52-5.77-.87-1.57,2.62-2.79,4.72-3.84,6.64-.53.87-.88,2.62-.53,3,.88.7,2.45,1.4,3.32.87A47.43,47.43,0,0,0,53.12,254c5.42-4.36,7.34-4.89,13.46-1.22,1.39-1.4,3-2.8,4.54-4.19,4.71-4.55,9.78-7.86,16.77-5.77A3.63,3.63,0,0,0,92.78,241.43Zm53.11,34.95a3.36,3.36,0,0,0-.87-2.28,31.52,31.52,0,0,0-5.24-4.36,34.74,34.74,0,0,0-4.2-1.75c-6.46,2.1-10.48,4.37-10.3,11.71.17,3.66,2.79,5.06,4.71,7.33a5.41,5.41,0,0,0,5.42,1.75C140.82,288.43,146.42,281.62,145.89,276.38ZM110.25,294a4.49,4.49,0,0,0-5.24,1.92c-1.05,1.4-2.27,2.8-3.32,4-2.79-1.92-.35-5.94-3.84-7.34-.35,1.05-.88,2.1-.7,3a7.83,7.83,0,0,1-1.57,6.47,6.69,6.69,0,0,0-1,3.32c-.18,1.22-.35,2.44-.53,3.49-1.39.18-2.27.18-3.84.35,2.45,4.19.52,7.86-.7,11.53l1.05.53a39.16,39.16,0,0,1,5.42-4c2.09-1.05,5.06-.7,7.33-3.85-2.09.35-3.32.7-4.54.88,3.15-2.27.7-5.42,1.75-8.56,1,.52,1.92.87,2.62,1.22a22.57,22.57,0,0,0,3.14,1.22c5.94.53,9.26-3.84,7.86-10.13A4.63,4.63,0,0,0,110.25,294ZM10.67,11.87A9.52,9.52,0,0,0,18.88,1a7.92,7.92,0,0,0-.24-1H3.16a10.29,10.29,0,0,0-.7,5.93C2.81,9.42,7,12.39,10.67,11.87ZM141,349.23c-4,.52-7,4.72-6.46,8.73l13.62-2.62C147.81,351.5,144.49,348.7,141,349.23ZM108,24.8c1.57,3,1.57,3,4.19,2.27a6.5,6.5,0,0,0,5.07-6.64,4.1,4.1,0,0,0-3.49-3.84c-3.15-.53-5.07,1.05-6.47,5.06,1,.53,2.1,1.05,3.67,1.93C109.73,24.1,109,24.45,108,24.8Zm40,282.32c-2.1.35-3,2.1-2.62,4.55.35,1.74,1.57,2.62,3.84,2.44,2.8-.17,5.07-3,5.94-7.86C152.7,306.6,150.26,306.6,148,307.12ZM14.69,67.43c-1.75-1.75-3.67-1.23-5.59,0-1.75,1-1.93,2.62-.18,3.84,2.8,1.92,5.94,2.8,10.31.52A51.33,51.33,0,0,0,14.69,67.43Zm103.42,58.35c-1.22,3-1.92,5.24-3,7.86,2.1.7,4.2,1.4,5.24-.52s1.23-4.55,1.58-6.82c0-.35-1-1.22-1.58-1.22A7,7,0,0,0,118.11,125.78Zm-14.5,222.57c4.37.53,6.64-1.22,6.47-5.41C106.23,341.54,104.66,342.94,103.61,348.35Zm7.69-195.84c-1.92,1.75-1.92,4-.7,6.29,3,0,3.84-2.1,4.37-4.2.17-.69-.18-2.27-.88-2.62A3.31,3.31,0,0,0,111.3,152.51Zm-8.91,170.34c.35-1.57-.18-2.62-1.92-2.62-1.57,0-3,.52-2.8,2.44a13.73,13.73,0,0,0,.7,3.5c1,.17,2.1.17,3.15.35C101.87,325,102,323.9,102.39,322.85ZM60.63,206.49c1.23-.17,2.8-3,2.1-4.19-.52-.87-2.1-1.92-2.79-1.75-1,.18-1.75,1.57-2.45,2.1C57.84,205.27,59.41,206.84,60.63,206.49Zm3.85-26.38c-5.24-2.09-5.42-2.09-5.59,1.4C62.21,181.86,62.21,181.86,64.48,180.11Zm24.28-70.06c.53-.69,1.4-1.39,1.58-2.09.17-.35-1-1-1.93-1.92-.52,1.22-1.22,1.92-1.22,2.62C87.19,109.18,88.24,109.53,88.76,110.05ZM20.8,155c-2.27-.35-2.44,1.22-2.27,3.31,1.75.35,3.49,1,3.84-1.22C22.37,156.35,21.33,155,20.8,155ZM163,354.12c2.62-.7,2.27-2.1,1.23-3.84C161.61,351.15,161.79,352.37,163,354.12Zm-39-184.32c.88.53,1.23,1,1.75,1,.35,0,.7-.52,1-.87a6.11,6.11,0,0,0-1-1C125.45,168.76,124.93,169.28,124.05,169.8ZM93.83,252.62a9.38,9.38,0,0,1,.7-1.05,2.76,2.76,0,0,1-1-.53c-.18.35-.52.7-.35.88C93,252.09,93.48,252.27,93.83,252.62Zm143.26-250c3.61,1.39,7.11,3.54,11,4.11V330.17a7.79,7.79,0,0,1-.71.54,2,2,0,0,0-.53,1.75c1,3.49-1.22,5.76-2.44,8.56-1.75,3.67-4.55,6.81-5.25,11.18-.17,1.05-1.22,1.92-2.27,3.32-2.44-3.15-2.27-6.47-3-9.44a23.83,23.83,0,0,1,.18-6.11q.25-5.76.52-11.53c0-2.62.18-5.42,0-8-.35-2.44-1-4.89-1.74-8,.34-.7,1-2.63,2.44-3.5,2.62-1.75,2.45-3.67,1.75-6.29a40.43,40.43,0,0,1-1.4-17.12c.87-5.59-.87-11.36-2.79-16.77-.35-1.05-1.23-2.27-2.1-2.45-.35-.17-.53-.17-.87-.35v.18c-.18.35,1.39,1.57.87,2.79a2.86,2.86,0,0,1-.7,1.23,3.2,3.2,0,0,1,1.75,1.92c.7,2.44,1.22,4.71,1.74,7.16a5.94,5.94,0,0,1-.87,1.92c-.35.7-1.22,1.57-1.05,2.27.88,4-2.27,6.29-3.84,9.26a5.18,5.18,0,0,1-1.4,1.4,84.86,84.86,0,0,1-1.57,9.26c0,5.07-1.05,10,.52,14.68.53,1.39-1.39,3.49-2.62,5.94.7,1.74,1.75,4,2.8,6.63-3.85,3.32-5.07,3.67-7.69,2.1a59.3,59.3,0,0,0-2.1,9.09c-.35,3.67.18,8.56-.52,12.23-.17,1-1.92,2.79-1.92,3.66-.18,1.23,1.75,1.58,1.57,2.8-.7,3.14-1.22,6.46-1.92,9.61,2.1-.7,4.37-1.22,6.46-1.92,1.58-.53,3.15-1.23,5.42-2.1,2.1,1.57,5.07,1.75,8.56-.17-.18-1.4-.52-2.63-.7-3.85.7,0,1.05-.17,1.22,0,4,4.54,8.56,8.74,11,14.5a4.47,4.47,0,0,0,1.92,2.1,14.08,14.08,0,0,0,1.24.71V411.4l-.19.2c-2.62,2.62-2.62,4-.17,7l.36.43v4.64a12.58,12.58,0,0,1-3,.17,65.35,65.35,0,0,1-8-1.22,5.77,5.77,0,0,1-4.19-4.9,28.22,28.22,0,0,1,0-7.68c.52-4,.69-4-3.32-6.47a48.67,48.67,0,0,1-2.62,4.2c-1.58-1.93-2.8-3.5-4.2-5.25a16.89,16.89,0,0,0-2.44.35c-3.5.35-5.42-1.22-4.72-4.71.35-2.27-.87-3.85-1.4-5.77a25.09,25.09,0,0,0-4.54-7.86,185.74,185.74,0,0,0-4,25.68c0,1.4,1.22,2.8,1.05,4.19-1.22,10.31-6.46,22-6.29,32.15.17,16.25,4.37,34.77,7,49.09,1.92,10.66,3.67,26-11,28.13-8.73,1.22-20.44-6.64-22-15.72-.53-2.8,1.75-6.64,1.4-10.14-.53-4.19-3-7.16-3-10.65.17-15.38,10.48-32.5,12.23-51.89.35-3.5-.88-6.47-.7-10,.35-5.94,3.49-12.23,3.67-18.17.35-11.7,2.79-29.18,6.29-43.5,1-4.19,3.66-7.34,3.66-10.31-.17-1.05-1.22-2.44-1-3.49,0-1.58,1.57-1.23,1.92-2.27,1.22-4.2-.35-11,1-16.6.69-2.8,2.79-4.37,3.14-6.64l-.17-.17H203c.35-3-1.57-5.24-1.4-8.91a8.22,8.22,0,0,1,.25-1.6,3.53,3.53,0,0,1-1.47.37c.17-.87.35-1.57.52-2.27.35.18.88.18,1.05.35a2.44,2.44,0,0,1,.22.47c.86-2.45,2.4-4.6,2.4-6.93,0-1.58-1.22-3.32-1.05-4.9.35-3.49,2.63-5.24,3.67-8.21,1.23-3.67.7-9.26,2.8-12.4a7.78,7.78,0,0,1,1.92-1.4,8.74,8.74,0,0,1,.7-1.92,3.9,3.9,0,0,0,.52-.87c.35-4.55-1.57-9.26,0-13.28a.18.18,0,0,0,.18-.18,6.08,6.08,0,0,1-2.27-.87c-2.62-1.57-5.24-3.14-7.69-4.89a26.46,26.46,0,0,1-4-3.49c-.7-.7-1.22-1.4-1.92-2.1v.17c.35,2.27-.52,3.32-2.27,4-5.42,2.1-6.81,6.47-6.29,11.53.52,4.72-1.57,8.56-4.19,11.88a60.62,60.62,0,0,1-16.6,16.07,57,57,0,0,1-5.94,3.15c1.05-3.67,1.05-6.64,2.79-9.61.88-1.75.7-4.54.18-6.64-.87-2.79-.18-4.89,2.27-6.11,2.27-1.05,2.8-2.62,2.45-4.9-.53-2.79-.53-5.76-1.4-8.38a14.81,14.81,0,0,0-3.32-5.42,52.68,52.68,0,0,0-8.21-8.21c-.18-1.39-.35-2.62-.53-3.84-.69-3.32-1.74-4.54-4.89-4.19-3.32.35-6.29-.18-8.73-2.63-.53-.52-1.75-.52-2.8-.69-1.22-.18-2.44.17-3.49-.18-3.32-1.05-5.94.18-8,2.62-2.27,2.8-4.54,3.85-8.21,2.8-2.1-.53-4.72.35-7.16.52a10.7,10.7,0,0,1-8.21-2.09,6.25,6.25,0,0,1-2.63-5.6c.18-2.27,0-4.71,0-7.51,1.75-1.39,4-.87,5.94-.52,4.55,1,9.09,0,13.63-.7a6.7,6.7,0,0,1,5.94,1.57c3.67,3.15,4.37,3,8-.17a8.79,8.79,0,0,1,3.49-1.57c.7-.36,1.75-.36,2.45-.7,4.89-2.62,8-2.1,11.88,2.27.17.17.35.52.52.7,2.45,2.62,5.07,2.79,8,.69a11.76,11.76,0,0,0,1.57-.87,9.25,9.25,0,0,0,3-4,32.66,32.66,0,0,1-1.4-7.16,12.55,12.55,0,0,0-4-2.1,10.67,10.67,0,0,0-7.69.35c-2.8,1.23-4.72.18-7.16-1.4-4.37-3-6.29-6.81-5.25-12,.18-1.4.18-3,.35-4.37.35-3.32-1.39-5.94-3.49-8a4.73,4.73,0,0,0-3.49-1.23,23.7,23.7,0,0,0-5.94,1.05c-1.23.18-2.45,1.05-3.67,1.05-6.29.17-10.84,3.67-15.55,7.34a26.61,26.61,0,0,1-4.37,2.44c-2.45,1-3.14,2.8-2.62,5.24.52,2.62.7,5.07-2.27,6.64-.7.35-.87,1.92-1.22,3-.53,1.58-.53,3.15-1.4,4.37A104.42,104.42,0,0,1,91,228.86c-.35.69-1.22,1-1.92,1.74-1.4-1.92-.35-3.32.35-4.54,2.62-4.37,2.8-8.39-.35-12.75-2.09-2.62-1.92-5.59.53-8.21,0-.18.17-.18.17-.35,1.57-4.72,5.94-6.12,10.13-7.52,4-1.57,4.9-3.49,2.62-7.16-1.74-3-3.66-5.59-7.51-5.94a3.59,3.59,0,0,1-2.79-1.75c-.7-3.32-2.8-3.32-5.42-2.44-.35-2.27,1.22-2.27,2.45-3a6,6,0,0,0,6.11,1.74,11.77,11.77,0,0,1,4.19.35c4.2,1.05,7.17-.69,9.61-3.49,3-3.32,4.72-4,9.09-2.62,2.09.7,4.37,1.4,6.46,2.27a13.9,13.9,0,0,0,12.06-.7c2.79-1.4,5.41-2.79,8-4.19,2.45-1.4,4.37-1.22,5.42.52-.18-.35-.35-.52-.52-.87-1.05-1.57-.7-3,.52-4.37,3.84-4.71,4-8.73.87-14a13.79,13.79,0,0,1-2.09-5.25c-.18-.87,0-2.44.7-3,2.44-1.92,1.74-4.54,1-6.64a14.74,14.74,0,0,1,.35-11.52c.88-2.1,2.45-4.2,1.92-6.82-.17-1,.7-2.45,1.4-3.49,2.1-3.15,2.1-3-.35-5.24a2.49,2.49,0,0,1-.7-.53c-2.62.18-5.06-1.4-7.33-5.07a10.31,10.31,0,0,0,2.09-.87c-4.71-7.69-4.19-15.55,1.58-23.06a7.27,7.27,0,0,0,1-5.94c-.17-1.57-.52-3-.87-5.59a25.14,25.14,0,0,1,3,1.4c2.27,1.39,4,1.39,5.77-1,1.57-2.1,4-3.5,6.11-5.24l3.32-2.8c2.62-2.09,4.89-4.37,7.69-5.94,3.67-2.09,6.29-4.37,5.06-9.08-.35-1.75.53-3,1.92-4,3.67-3,3.67-4,.35-6.81-3-2.62-3.66-5.42-3.32-9.09a22.24,22.24,0,0,0-.17-6.81c-.87-4.54-1.75-5.42-6.46-5.42-2.45,0-3.5-1-4-3.14-1.4-6.12-5.94-8.56-11.71-8.74A14.43,14.43,0,0,1,150.75,0h84.11A5.57,5.57,0,0,0,237.09,2.61ZM150.43,170.68c1.4,2.44,3,4.72,4.55,7a37.22,37.22,0,0,1,2.79,4.36,23.37,23.37,0,0,0-2.79-4.36C153.4,175.22,152,173,150.43,170.68Zm3.49,13.43c-1.39-3.49-1.91-7.33-2.61-11.16C152,176.78,152.36,180.62,153.92,184.11Zm7,9.46a2.85,2.85,0,0,0-.7.87c-3-3-4.71-6.62-6.28-10.29,1.39,3.67,3.14,7.33,6.28,10.29A3.3,3.3,0,0,0,160.92,193.57ZM235,0a6.36,6.36,0,0,0,2.11,2.44C240.7,4,244.2,6,248.11,6.56V0ZM122.31,39.82c3,2.27,5.06,5.94,9.6,5.77.7,0,1.58.87,2.45,1.4.7.35,1.4,1.22,1.92,1.22,2.8-.18,5.42-.35,8.21-.7,2.27-.35,2.62-2.62,3.67-4.19,1.23-1.75,2.45-2.1,3.85-.53a15.72,15.72,0,0,1,2.09,2.62c1.05,1.05,2.27,1.05,3.32-.52-1-1.75-2.79-3.49-3.32-5.59-1.92-6.29-6.64-9.78-11.53-13.1-4.37-3-9.43-2.8-13.8-.88-3.67,1.57-5.94,5.24-7.69,8.91A4.32,4.32,0,0,0,122.31,39.82ZM103.44,414.74c-.7,0-1.23-.17-2.27-.17-2.8-.18-5.07,1.4-5.42,3.84-.35,1.92,4,8.91,5.77,9.26a6.83,6.83,0,0,0,1.92,0c4.54-.7,6.46-3.32,6.11-8.73C109.38,415.79,108.5,415.27,103.44,414.74Zm131.73,17.65c-.53,1.92-1,3.84-1.4,5.59,1.4,2.45,5.24,3.32,3.84,6.81-.52,1.58-.17,2.62,1.23,3.15,1.74.52,2.79-.53,3.14-2.27s.87-3.5,1.05-5.24C243.55,435.88,240.23,432.39,235.17,432.39ZM167.56,317.08c-4.72-.52-7.34-2.79-9.26-6.64-.18-.35-.7-.52-1.4-.87.17,1.92.7,3.67.52,5.24-.35,4.19-.17,4.72,4,5.07,1.75.17,3.32.17,4,1.92,1,2.79,3.14,2.27,5.76,2.1C171.05,320.75,170.87,317.43,167.56,317.08ZM223.29,347c1-4.55.52-5.42-3.5-7C218.39,344,219.27,345.91,223.29,347ZM159,335.78c-.87-.35-2.27.69-3.84,1.22,2.45,2.62,2.45,2.62,5.94,1.92C160.39,337.7,159.87,336.13,159,335.78Zm34.07-2.27c-1.92-3.15-1.92-3.15-5.24-.7C189.39,334.55,191,334.9,193.06,333.51ZM88.24,155.13c-.18.35.7,1.22,1.4,2.27a18.82,18.82,0,0,0,2.09-2.8c.18-.34-.87-1-1.22-1.57C89.46,153.73,88.59,154.26,88.24,155.13ZM105.18,8.38c.35-.18.35-.7.53-1.23-.7-.35-1.57-.52-2.45-.87C103.09,8.38,103.61,9.07,105.18,8.38ZM121.61,358a4,4,0,0,0,1.74,1.23c.35,0,.88-.7,1.58-1.4a15.77,15.77,0,0,0-2.27-1.22C122.48,356.57,122,357.44,121.61,358Zm15.9-109.89c-.7-2.62-1-4.54-1.4-6.29-1.92-.69-3.67-.69-4,1.23-.18,1,.87,2.62,1.92,3.49C134.71,247.2,136.11,247.37,137.51,248.07Z', fill='red')

                            g(clip-path='url(#clip-path-gg)')
                                circle(cx='250', cy='20', r='2', fill='red', ref='bloodcircleone')
                                circle(cx='270', cy='100', r='2', fill='red', ref='bloodcircletwo')
                                circle(cx='280', cy='200', r='2', fill='red', ref='bloodcirclethree')



                    .opg__text(
                        v-html='section.heading',
                        ref='bloodtext'
                        )
                
                .opg__moto(
                    :class='{show: isShownMoto && !introEnded}'
                    )
                    .opg__moto-pusher
                    .opg__moto-wrp
                        .opg__moto-text
                            p(
                                v-for='(paragraph, paragraphIndex) in section.moto'
                                )
                                span.opg__moto-word(
                                    ref='word', 
                                    v-for='(word, index) in paragraph.split(" ")',
                                    v-html='word'
                                    )

                        p.opg__moto-nextlink(
                            @click='initSelectorSlider'
                            )
                            span(
                                v-html='section.nextsection'
                            )
                
                .opg__sections-wrapper(
                    ref='sectionswrapper'
                    )

                    component(
                        v-for='(componentObj, componentIndex) in section.articles',
                        :is='componentObj.id',
                        :sectionItem='componentObj',
                        :isActive='currentSection === componentIndex',
                        @showend='animationShawn(componentObj.id)',
                        @hideend='animationEnded(componentObj.id)',
                        @nextSection='changeSection("next")',
                        @prevSection='changeSection("prev")',
                        :ref='componentObj.id',
                        :key='componentObj.id'

                    )
                        
                    .sections-ui
                        .sections-ui__wrapper
                            router-link.sections-ui__read(
                                v-html='section.read',
                                v-if='currentSection >= 0'
                                :to='`/${$attrs.category}/${section.articles[currentSection].id}`',
                                :class='{hide: animationPending}'
                                )

                            //-.sections-ui__next(
                                v-html='section.next',
                                @click='changeSection("next")',
                                :class='{hide: currentSection === section.articles.length - 1 || animationPending}'
                                )


            

</template>

<script>
import sectionData from '@/assets/data/menu';
import {gsap} from 'gsap';

import Firstbandera from '@/components/animationsselector/firstbandera';
import Rampantcrime from '@/components/animationsselector/rampantcrime';
import Mafiavivasempre from '@/components/animationsselector/mafiavivasempre';

export default {
    name: 'Selector',

    components: {
        firstbandera: Firstbandera,
        rampantcrime: Rampantcrime,
        mafiavivasempre: Mafiavivasempre
    },

    data() {
        return {
            section: sectionData[this.$attrs.category],
            tl: null,
            tlSec: null,
            motoTl: null,
            currentSection: -1,
            currentSectionId: '',
            animationPending: true,
            introEnded: false,
            isShownMoto: false,
            scrollLisener: null,
            isActivatedScroll: false
        };
    },

    beforeMount() {
        this.$store.commit('setColor', this.section.articles[0].theme);
    },

    mounted() {
        this.$store.commit('setTheme', 'white');

        if (this.$attrs.category === 'opg') this.startOpgAnimation();

        this.scrollLisener = window.addEventListener('scroll', this.checkScroll);
    },

    methods: {
        checkScroll() {
            window.scrollTo(0, 0);

            if (this.isActivatedScroll) {
                this.$router.push(`/${this.$attrs.category}/${this.section.articles[this.currentSection].id}`);
                window.removeEventListener('scroll', this.checkScroll);
            }
        },

        animationShawn(id) {
            this.currentSection = this.section.articles.findIndex(el => el.id === id);
            this.animationPending = false;
        },

        animationEnded() {
            if (this.currentSection === this.section.articles.length - 1) return;

            this.currentSectionId = this.section.articles[this.currentSection].id;
        },

        startOpgAnimation() {
            // const initSelectorSlider = () => this.initSelectorSlider();
            const showMoto = () => this.showMoto();

            this.tl = gsap.timeline({paused: true, onComplete: showMoto});

            this.tl
                .fromTo(this.$refs.bullet[0], 0.6, {x: '-100%'}, {x: window.innerWidth + 400, ease: 'power2.in'}, 'start')
                .fromTo(this.$refs.bullet[1], 0.6, {x: '-100%'}, {x: window.innerWidth + 400, ease: 'power2.in'}, 'start+=0.1')
                .fromTo(this.$refs.bloodcircleone, 2.2, {attr: {r: 2}}, {attr: {r: 647}}, 'start+=0.6')
                .fromTo(this.$refs.bloodcircletwo, 2.1, {attr: {r: 2}}, {attr: {r: 647}}, 'start+=0.6')
                .fromTo(this.$refs.bloodcirclethree, 1, {attr: {r: 2}}, {attr: {r: 647}}, 'start+=0.5')
                .fromTo(this.$refs.bloodtext, 2, {backgroundPosition: '0 510%'}, {backgroundPosition: '122% 0%'}, 'start+=0.8');

            this.tl.play();
        },

        showMoto() {
            this.isShownMoto = true;

            this.motoTl = gsap.timeline();
            this.motoTl
                .set(this.$refs.word, {opacity: 0, x: '-10', y: '-2'})
                .to(this.$refs.word, {delay: 0.7, duration: 0.8, opacity: 1, x: '0', y: '0', stagger: {amount: 2, from: 'center', grid: 'auto'}});
        },

        initSelectorSlider() {
            this.currentSection = 0;

            const setIntroEnded = () => {
                this.isActivatedScroll = true;
                this.animationPending = true;
                this.isShownMoto = false;
                this.introEnded = true;
            };

            if (this.motoTl) {
                this.motoTl.pause();
                this.motoTl.kill();
            }

            this.tlSec = gsap.timeline({paused: true, onComplete: setIntroEnded});

            this.tlSec.fromTo(this.$refs.introwrapper, 0.3, {opacity: 1}, {opacity: 0}, 'start');

            this.tlSec.play();
        },

        changeSection(direction) {
            if (!this.introEnded) return;
            if (direction === 'next' && this.currentSection !== this.section.articles.length - 1) {
                ++this.currentSection;
                this.animationPending = true;
            }
            if (direction === 'prev' && this.currentSection !== 0) {
                --this.currentSection;
                this.animationPending = true;
            }
            this.$store.commit('setColor', this.section.articles[this.currentSection].theme);
        },

        goToSection(id) {
            this.$router.push(`/${this.$attrs.category}/${this.section.articles[id].id}`);
        }
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.checkScroll);
        if (this.tl) this.tl.kill();
        if (this.tlSec) this.tlSec.kill();
    },

    beforeRouteLeave(to, from, next) {
        to;
        from;

        this.$refs.curtain.classList.add('show');

        setTimeout(() => {
            next();
        }, 600);
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.opg {
    position: absolute;
    width: 100%;
    height: 100vh;
    // height: calc(var(--vh) * 100);
    top: 0;
    left: 0;

    &__moto {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 50;
        //padding-bottom: 15vh;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
        color: #fff;
        @media (--viewport-tablet) {
            // overflow: scroll;
            top: 28px;
            height: calc(100vh - 28px);
            justify-content: flex-start;
            // height: auto;
            // min-height: 100vh;
        }

        &-wrp {
            @media (--viewport-tablet) {
                max-height: calc(100 * var(--vh) - 28px);
                padding-bottom: calc(var(--vh) * 5);
                overflow-y: scroll;
            }
        }
        &-word {
            padding-right: 0.5em;
        }

        &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            transform-origin: 0% 100%;
            background: black;
            transform: scaleY(0);
            transition: transform 0.6s ease-in 0.1s;
        }

        &-text {
            position: relative;
            z-index: 5;
            max-width: calc(var(--grid-column) * 9);

            @media (--viewport-laptop) {
                max-width: calc(var(--grid-column) * 17);
            }

            @media (--viewport-tablet) {
                width: 100%;
                padding: calc(var(--vh) * 4) var(--grid-column-mobile) 0;
            }

            p {
                display: flex;
                flex-wrap: wrap;
            }
            p:not(:last-child) {
                margin-bottom: 1em;
            }
        }

        &-nextlink {
            position: relative;
            z-index: 5;
            pointer-events: all;
            //text-decoration: underline;
            cursor: url('../assets/img/ui/sniper-scope-pointer-red.png') 18 18, pointer;
            transition: opacity 0.3s ease;
            opacity: 0;
            pointer-events: none;
            font-size: 0.75rem;
            text-transform: uppercase;
            font-family: var(--font-accent);
            font-weight: 800;
            font-size: 1.25rem;
            padding: 25px 25px 25px 0;
            @media (--viewport-mobile-s) {
                padding: 10px;
            }

            @media (--viewport-tablet) {
                //font-size: 11.5px;
                padding: 25px var(--grid-column-mobile);
            }
        }

        &.show {
            opacity: 1;
            pointer-events: all;

            &:before {
                transform: scaleY(1);
                transition: transform 0.6s ease-out 0.2s;
            }

            .opg__moto-nextlink {
                pointer-events: all;
                opacity: 1;
                transition: opacity 0.3s ease 0.6s;
            }
        }
    }

    &__intro-wrapper,
    &__sections-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    // &__sections-wrapper {
    //     opacity: 0;
    // }

    &__bullets {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        padding-top: 35vh;

        &-bullet {
            position: relative;
            display: block;
            width: 228px;
            margin-bottom: 60px;
            transform: translateX(-100%);
        }
    }

    &__blooddrop {
        position: absolute;
        right: 0;
        top: 0;

        @media (--viewport-tablet) {
            top: unset;
            bottom: calc(0% - 120px);
            transform: rotate(90deg);
        }
    }

    &__text {
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        width: var(--grid-width);
        margin: 0 auto;
        padding-top: 77px;
        line-height: 1.2;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: url(../assets/img/selector/blood.svg);
        background-position: 0 510%;
        background-repeat: repeat-x;
        background-size: 140% 140%;

        @media (--viewport-tablet) {
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }
}

.sections-ui {
    pointer-events: none;
    position: fixed;
    z-index: 18;
    top: 95vh;
    top: calc(var(--vh) * 95);
    left: 0;
    width: 100%;
    color: white;
    font-size: 0.75rem;
    text-transform: uppercase;

    &__wrapper {
        width: var(--grid-width);
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        @media (--viewport-laptop) {
            width: 100%;
            padding: 0 var(--grid-column-laptop);
        }

        @media (--viewport-tablet) {
            padding-left: var(--grid-column-mobile);
        }
    }

    &__read,
    &__next {
        pointer-events: all;
        color: white;
        text-decoration: none;
        cursor: url('../assets/img/ui/sniper-scope-pointer-red.png') 18 18, pointer;
        transition: opacity 0.3s ease;

        @media (--viewport-tablet) {
            font-size: 11.5px;
        }

        &.hide {
            pointer-events: none;
            opacity: 0;
        }
    }

    &__read {
        &:after {
            content: '▼';
            display: inline-block;
            margin-left: 5px;
        }
    }
}

.section {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    &__image-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    &__image-grid-container {
        position: relative;
        width: var(--grid-width);
        height: 100vh;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        @media (--viewport-laptop) {
            width: 100%;
        }

        @media (--viewport-tablet) {
            width: 100%;
        }
    }

    &__image-container {
        width: calc(var(--grid-column) * 18);
        height: calc((var(--grid-column) * 18) * (439 / 876));
        overflow: hidden;

        @media (--viewport-laptop) {
            width: calc(var(--grid-column-laptop) * 18);
            height: calc((var(--grid-column-laptop) * 18) * (439 / 876));
        }

        @media (--viewport-tablet) {
            width: calc(var(--grid-column-mobile) * 11);
            height: 70vh;
        }
    }

    &__image {
        width: 100%;
        height: auto;
        transform: translateX(100%);

        @media (--viewport-tablet) {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }

    &__text-wrapper {
        position: relative;
        display: block;
        z-index: 20;
        width: var(--grid-width);
        margin: 0 auto;
        padding-top: 77px;
        pointer-events: none;

        @media (--viewport-laptop) {
            width: 100%;
            padding: 77px var(--grid-column-laptop) 0 var(--grid-column-laptop);
        }

        @media (--viewport-tablet) {
            width: auto;
            height: auto;
            padding-top: 0px;
            top: 77px;
        }
    }

    &.active {
        .section__text-wrapper {
            pointer-events: all;
        }
    }

    &__text-block {
        position: relative;
        display: block;
        overflow: hidden;
    }

    &__text {
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        line-height: 1.2;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: url(../assets/img/selector/firstbandera-fill.jpg);
        background-size: cover;
        transform: translateY(150%);

        @media (--viewport-tablet) {
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }

    &__text--white {
        position: absolute;
        left: 0;
        top: -11px;
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        opacity: 0;

        @media (--viewport-tablet) {
            top: -8%;
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }
}

.selector {
    position: absolute;
    z-index: 6;
    width: 100%;
    height: calc(100vh + 1px);
    top: 0;
    left: 0;
    background: black;

    &__opg {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        background: var(--color-black);
        overflow: hidden;
    }

    &__curtain {
        position: absolute;
        z-index: 50;
        pointer-events: none;
        background: var(--theme);
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        transform: scaleY(0);
        transition: 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
        transform-origin: 0 100%;

        &.show {
            transform: scaleY(1);
        }
    }
}
</style>
